/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddEditTimeslotBodyBody,
    DeleteTimeslot200,
    GetTimeslotDynamicPricesParams,
    GetTimeslotsParams,
    RentalDayBodyBody,
    RentalDaySuccessResponseResponse,
    RequestStatusResponseResponse,
    TimeslotCreateSuccessResponseResponse,
    TimeslotDynamicPrices,
    TimeslotPrices,
    TimeslotSuccessResponseResponse,
    TimeslotsSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Add new timeslot
 */
export const addTimeslot = (
    addEditTimeslotBodyBody: AddEditTimeslotBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<TimeslotCreateSuccessResponseResponse>({
        url: `/timeslots`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addEditTimeslotBodyBody,
        signal,
    });
};

export const getAddTimeslotMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addTimeslot>>,
        TError,
        { data: AddEditTimeslotBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addTimeslot>>,
    TError,
    { data: AddEditTimeslotBodyBody },
    TContext
> => {
    const mutationKey = ['addTimeslot'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addTimeslot>>,
        { data: AddEditTimeslotBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return addTimeslot(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddTimeslotMutationResult = NonNullable<Awaited<ReturnType<typeof addTimeslot>>>;
export type AddTimeslotMutationBody = AddEditTimeslotBodyBody;
export type AddTimeslotMutationError = APIErrorResponseResponse;

/**
 * @summary Add new timeslot
 */
export const useAddTimeslot = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addTimeslot>>,
        TError,
        { data: AddEditTimeslotBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addTimeslot>>,
    TError,
    { data: AddEditTimeslotBodyBody },
    TContext
> => {
    const mutationOptions = getAddTimeslotMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get timeslots matching the filters
 */
export const getTimeslots = (params?: GetTimeslotsParams, signal?: AbortSignal) => {
    return customInstance<TimeslotsSuccessResponseResponse>({
        url: `/timeslots`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetTimeslotsQueryKey = (params?: GetTimeslotsParams) => {
    return [`/timeslots`, ...(params ? [params] : [])] as const;
};

export const getGetTimeslotsQueryOptions = <
    TData = Awaited<ReturnType<typeof getTimeslots>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetTimeslotsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getTimeslots>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTimeslotsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimeslots>>> = ({ signal }) =>
        getTimeslots(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTimeslots>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTimeslotsQueryResult = NonNullable<Awaited<ReturnType<typeof getTimeslots>>>;
export type GetTimeslotsQueryError = APIErrorResponseResponse;

/**
 * @summary Get timeslots matching the filters
 */

export function useGetTimeslots<
    TData = Awaited<ReturnType<typeof getTimeslots>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetTimeslotsParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getTimeslots>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetTimeslotsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get timeslot by id
 */
export const getTimeslot = (id: number, signal?: AbortSignal) => {
    return customInstance<TimeslotSuccessResponseResponse>({
        url: `/timeslots/${id}`,
        method: 'GET',
        signal,
    });
};

export const getGetTimeslotQueryKey = (id?: number) => {
    return [`/timeslots/${id}`] as const;
};

export const getGetTimeslotQueryOptions = <
    TData = Awaited<ReturnType<typeof getTimeslot>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getTimeslot>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTimeslotQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimeslot>>> = ({ signal }) =>
        getTimeslot(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTimeslot>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTimeslotQueryResult = NonNullable<Awaited<ReturnType<typeof getTimeslot>>>;
export type GetTimeslotQueryError = APIErrorResponseResponse;

/**
 * @summary Get timeslot by id
 */

export function useGetTimeslot<
    TData = Awaited<ReturnType<typeof getTimeslot>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getTimeslot>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetTimeslotQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit timeslot
 */
export const editTimeslot = (id: number, addEditTimeslotBodyBody: AddEditTimeslotBodyBody) => {
    return customInstance<TimeslotSuccessResponseResponse>({
        url: `/timeslots/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: addEditTimeslotBodyBody,
    });
};

export const getEditTimeslotMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editTimeslot>>,
        TError,
        { id: number; data: AddEditTimeslotBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editTimeslot>>,
    TError,
    { id: number; data: AddEditTimeslotBodyBody },
    TContext
> => {
    const mutationKey = ['editTimeslot'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editTimeslot>>,
        { id: number; data: AddEditTimeslotBodyBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return editTimeslot(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditTimeslotMutationResult = NonNullable<Awaited<ReturnType<typeof editTimeslot>>>;
export type EditTimeslotMutationBody = AddEditTimeslotBodyBody;
export type EditTimeslotMutationError = APIErrorResponseResponse;

/**
 * @summary Edit timeslot
 */
export const useEditTimeslot = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editTimeslot>>,
        TError,
        { id: number; data: AddEditTimeslotBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editTimeslot>>,
    TError,
    { id: number; data: AddEditTimeslotBodyBody },
    TContext
> => {
    const mutationOptions = getEditTimeslotMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete timeslot by id
 */
export const deleteTimeslot = (id: number) => {
    return customInstance<DeleteTimeslot200>({ url: `/timeslots/${id}`, method: 'DELETE' });
};

export const getDeleteTimeslotMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteTimeslot>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteTimeslot>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['deleteTimeslot'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteTimeslot>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return deleteTimeslot(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteTimeslotMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTimeslot>>>;

export type DeleteTimeslotMutationError = APIErrorResponseResponse;

/**
 * @summary Delete timeslot by id
 */
export const useDeleteTimeslot = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteTimeslot>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteTimeslot>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getDeleteTimeslotMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Send seating assignment locked email for a timeslot
 */
export const sendTimeslotSeatingLockEmail = (id: number, signal?: AbortSignal) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/timeslots/${id}/seating-lock-email`,
        method: 'POST',
        signal,
    });
};

export const getSendTimeslotSeatingLockEmailMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sendTimeslotSeatingLockEmail>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof sendTimeslotSeatingLockEmail>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['sendTimeslotSeatingLockEmail'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof sendTimeslotSeatingLockEmail>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return sendTimeslotSeatingLockEmail(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type SendTimeslotSeatingLockEmailMutationResult = NonNullable<
    Awaited<ReturnType<typeof sendTimeslotSeatingLockEmail>>
>;

export type SendTimeslotSeatingLockEmailMutationError = APIErrorResponseResponse;

/**
 * @summary Send seating assignment locked email for a timeslot
 */
export const useSendTimeslotSeatingLockEmail = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof sendTimeslotSeatingLockEmail>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof sendTimeslotSeatingLockEmail>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getSendTimeslotSeatingLockEmailMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get per-timeslot ticket type/option price overrides
 */
export const getTimeslotPrices = (id: number, signal?: AbortSignal) => {
    return customInstance<TimeslotPrices>({
        url: `/timeslots/${id}/prices`,
        method: 'GET',
        signal,
    });
};

export const getGetTimeslotPricesQueryKey = (id?: number) => {
    return [`/timeslots/${id}/prices`] as const;
};

export const getGetTimeslotPricesQueryOptions = <
    TData = Awaited<ReturnType<typeof getTimeslotPrices>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTimeslotPrices>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTimeslotPricesQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimeslotPrices>>> = ({ signal }) =>
        getTimeslotPrices(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTimeslotPrices>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTimeslotPricesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTimeslotPrices>>
>;
export type GetTimeslotPricesQueryError = APIErrorResponseResponse;

/**
 * @summary Get per-timeslot ticket type/option price overrides
 */

export function useGetTimeslotPrices<
    TData = Awaited<ReturnType<typeof getTimeslotPrices>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getTimeslotPrices>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetTimeslotPricesQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Replaces the full set of price overrides for the timeslot. Any (ticket type, ticket option) pair omitted from the payload is cleared and falls back to the show-level default price. Reused by both the admin UI and the dynamic-pricing engine.
 * @summary Set per-timeslot ticket type/option price overrides
 */
export const setTimeslotPrices = (id: number, timeslotPrices: TimeslotPrices) => {
    return customInstance<TimeslotPrices>({
        url: `/timeslots/${id}/prices`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: timeslotPrices,
    });
};

export const getSetTimeslotPricesMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof setTimeslotPrices>>,
        TError,
        { id: number; data: TimeslotPrices },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof setTimeslotPrices>>,
    TError,
    { id: number; data: TimeslotPrices },
    TContext
> => {
    const mutationKey = ['setTimeslotPrices'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof setTimeslotPrices>>,
        { id: number; data: TimeslotPrices }
    > = (props) => {
        const { id, data } = props ?? {};

        return setTimeslotPrices(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SetTimeslotPricesMutationResult = NonNullable<
    Awaited<ReturnType<typeof setTimeslotPrices>>
>;
export type SetTimeslotPricesMutationBody = TimeslotPrices;
export type SetTimeslotPricesMutationError = APIErrorResponseResponse;

/**
 * @summary Set per-timeslot ticket type/option price overrides
 */
export const useSetTimeslotPrices = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof setTimeslotPrices>>,
        TError,
        { id: number; data: TimeslotPrices },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof setTimeslotPrices>>,
    TError,
    { id: number; data: TimeslotPrices },
    TContext
> => {
    const mutationOptions = getSetTimeslotPricesMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * When the show's venue has an enabled dynamic-pricing integration, returns the provider's most recently pushed prices for this timeslot's sellable ticket type/option combos (a manually-set TimeslotPrices override always wins over a pushed price for the same combo). When the integration is off, or no combo has a live pushed price, returns enabled:false and the caller keeps the original pricing.
 * @summary Get the current dynamic prices for a timeslot
 */
export const getTimeslotDynamicPrices = (
    id: number,
    params?: GetTimeslotDynamicPricesParams,
    signal?: AbortSignal,
) => {
    return customInstance<TimeslotDynamicPrices>({
        url: `/timeslots/${id}/dynamic-prices`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetTimeslotDynamicPricesQueryKey = (
    id?: number,
    params?: GetTimeslotDynamicPricesParams,
) => {
    return [`/timeslots/${id}/dynamic-prices`, ...(params ? [params] : [])] as const;
};

export const getGetTimeslotDynamicPricesQueryOptions = <
    TData = Awaited<ReturnType<typeof getTimeslotDynamicPrices>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    params?: GetTimeslotDynamicPricesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getTimeslotDynamicPrices>>,
            TError,
            TData
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTimeslotDynamicPricesQueryKey(id, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimeslotDynamicPrices>>> = ({
        signal,
    }) => getTimeslotDynamicPrices(id, params, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTimeslotDynamicPrices>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetTimeslotDynamicPricesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTimeslotDynamicPrices>>
>;
export type GetTimeslotDynamicPricesQueryError = APIErrorResponseResponse;

/**
 * @summary Get the current dynamic prices for a timeslot
 */

export function useGetTimeslotDynamicPrices<
    TData = Awaited<ReturnType<typeof getTimeslotDynamicPrices>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    params?: GetTimeslotDynamicPricesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getTimeslotDynamicPrices>>,
            TError,
            TData
        >;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetTimeslotDynamicPricesQueryOptions(id, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Create a configured rental day's timeslots atomically
 */
export const createRentalDay = (
    showId: number,
    rentalDayBodyBody: RentalDayBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<RentalDaySuccessResponseResponse>({
        url: `/shows/${showId}/rental-days`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: rentalDayBodyBody,
        signal,
    });
};

export const getCreateRentalDayMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createRentalDay>>,
        TError,
        { showId: number; data: RentalDayBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof createRentalDay>>,
    TError,
    { showId: number; data: RentalDayBodyBody },
    TContext
> => {
    const mutationKey = ['createRentalDay'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof createRentalDay>>,
        { showId: number; data: RentalDayBodyBody }
    > = (props) => {
        const { showId, data } = props ?? {};

        return createRentalDay(showId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateRentalDayMutationResult = NonNullable<
    Awaited<ReturnType<typeof createRentalDay>>
>;
export type CreateRentalDayMutationBody = RentalDayBodyBody;
export type CreateRentalDayMutationError = APIErrorResponseResponse;

/**
 * @summary Create a configured rental day's timeslots atomically
 */
export const useCreateRentalDay = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createRentalDay>>,
        TError,
        { showId: number; data: RentalDayBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof createRentalDay>>,
    TError,
    { showId: number; data: RentalDayBodyBody },
    TContext
> => {
    const mutationOptions = getCreateRentalDayMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Move/edit an existing rental day's timeslots atomically; bookings follow their timeslots
 */
export const editRentalDay = (groupId: number, rentalDayBodyBody: RentalDayBodyBody) => {
    return customInstance<RentalDaySuccessResponseResponse>({
        url: `/rental-days/${groupId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: rentalDayBodyBody,
    });
};

export const getEditRentalDayMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editRentalDay>>,
        TError,
        { groupId: number; data: RentalDayBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editRentalDay>>,
    TError,
    { groupId: number; data: RentalDayBodyBody },
    TContext
> => {
    const mutationKey = ['editRentalDay'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editRentalDay>>,
        { groupId: number; data: RentalDayBodyBody }
    > = (props) => {
        const { groupId, data } = props ?? {};

        return editRentalDay(groupId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditRentalDayMutationResult = NonNullable<Awaited<ReturnType<typeof editRentalDay>>>;
export type EditRentalDayMutationBody = RentalDayBodyBody;
export type EditRentalDayMutationError = APIErrorResponseResponse;

/**
 * @summary Move/edit an existing rental day's timeslots atomically; bookings follow their timeslots
 */
export const useEditRentalDay = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editRentalDay>>,
        TError,
        { groupId: number; data: RentalDayBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editRentalDay>>,
    TError,
    { groupId: number; data: RentalDayBodyBody },
    TContext
> => {
    const mutationOptions = getEditRentalDayMutationOptions(options);

    return useMutation(mutationOptions);
};
